import layoutDocument from "@react-pdf/layout";
import { Font, pdf } from "@react-pdf/renderer";

// largeur fixe du ticket B7 
export const TICKET_ROLL_WIDTH_PT = 298;

// Hauteur de page provisoire pour le calcul de layout
export const TICKET_MEASURE_MAX_HEIGHT_PT = 100000;

const TICKET_PAGE_MIN_HEIGHT_PT = 120;
const HEIGHT_SAFETY_PT = 8;

/**
 * Parcourt l'arbre de layout @react-pdf et retourne la coordonnée Y maximale du contenu.
 * @param {object} node
 * @returns {number}
 */
function maxContentBottom(node) {
  if (!node || typeof node !== "object") {
    return 0;
  }

  let m = 0;

  if (
    node.box
    && Number.isFinite(node.box.top)
    && Number.isFinite(node.box.height)
  ) {
    m = Math.max(m, node.box.top + node.box.height);
  }

  if (Array.isArray(node.lines)) {
    const parentTop = node.box && Number.isFinite(node.box.top) ? node.box.top : 0;
    for (let i = 0; i < node.lines.length; i += 1) {
      const line = node.lines[i];
      const b = line.box || line.rect;
      if (b && Number.isFinite(b.y) && Number.isFinite(b.height)) {
        m = Math.max(m, parentTop + b.y + b.height);
      }
    }
  }

  const children = node.children;
  if (children && children.length) {
    for (let j = 0; j < children.length; j += 1) {
      m = Math.max(m, maxContentBottom(children[j]));
    }
  }

  return m;
}

/**
 * Retourne le bas max du contenu en excluant la boîte racine de page.
 * @param {object} page
 * @returns {number}
 */
function getPageContentBottom(page) {
  if (!page || !Array.isArray(page.children) || page.children.length === 0) {
    return 0;
  }

  let maxBottom = 0;

  for (let i = 0; i < page.children.length; i += 1) {
    maxBottom = Math.max(maxBottom, maxContentBottom(page.children[i]));
  }

  return maxBottom;
}

/**
 * Mesure la hauteur nécessaire pour une seule page PDF (largeur fixe, hauteur = contenu).
 * Passe 1 : page très haute, wrap désactivé, puis lecture du layout Yoga.
 *
 * @param {import("react").ReactElement} documentElement document React-PDF 
 * @returns {Promise<number>} hauteur de page en points
 */
export async function measureTicketPageHeightPt(documentElement) {
  const instance = pdf();
  instance.updateContainer(documentElement);

  const doc = instance.container.document;
  if (!doc) {
    return TICKET_PAGE_MIN_HEIGHT_PT;
  }

  const laidOut = await layoutDocument(doc, Font);
  const page = laidOut.children && laidOut.children[0];
  if (!page) {
    return TICKET_PAGE_MIN_HEIGHT_PT;
  }

  const contentBottom = getPageContentBottom(page);
  const paddingBottom = page.box && Number.isFinite(page.box.paddingBottom)
    ? page.box.paddingBottom
    : 7;

  const raw = contentBottom + paddingBottom + HEIGHT_SAFETY_PT;
  const rounded = Math.ceil(Math.min(raw, TICKET_MEASURE_MAX_HEIGHT_PT));

  return Math.max(rounded, TICKET_PAGE_MIN_HEIGHT_PT);
}
